/* eslint-disable import/prefer-default-export */
import { message } from "antd";

/** 跳出「必填欄位未填」的 antd 警告訊息 */
export const showRequiredFieldsWarning = () => {
  message.warning("必填欄位未填");
};
